import type { QualifySelectedPlace } from '@/lib/producer-qualify';

/* ── Step identity ──────────────────────────────────── */

export const STEP_IDS = ['place', 'name', 'offerings'] as const;
export type StepId = (typeof STEP_IDS)[number];

/* ── Draft (user-entered data) ──────────────────────── */

export interface WizardDraft {
  selectedPlace: QualifySelectedPlace | null;
  producerName: string;
  offerings: string[];
  contactEmail: string;
}

/* ── Wizard state ───────────────────────────────────── */

export interface WizardState {
  currentStep: StepId;
  draft: WizardDraft;
  hydrated: boolean;
}

/* ── Actions ────────────────────────────────────────── */

export type WizardAction =
  | { type: 'HYDRATE'; draft: Partial<WizardDraft>; step?: StepId }
  | { type: 'SET_SELECTED_PLACE'; place: QualifySelectedPlace | null }
  | { type: 'SET_PRODUCER_NAME'; name: string }
  | { type: 'SET_OFFERINGS'; offerings: string[] }
  | { type: 'SET_CONTACT_EMAIL'; email: string }
  | { type: 'GO_NEXT' }
  | { type: 'GO_BACK' }
  | { type: 'GO_TO_STEP'; step: StepId };
